import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { PesquisaQuestionarioSatisfacao } from "../entrega/types/questionario_satisfacao";

type TInitialState = {
  pesquisa: PesquisaQuestionarioSatisfacao | null;
  pesquisa_updated_at?: Date;
  clientesQueResponderamQuestionario: string[];
};

const initialState: TInitialState = {
  pesquisa: null,
  clientesQueResponderamQuestionario: [],
};

const reducer = createSlice({
  name: "questionarioSatisfacao",
  initialState,
  reducers: {
    questionarioSatisfacaoRequest(_state) {},
    questionarioSatisfacaoRequestSuccess(
      state,
      { payload }: PayloadAction<PesquisaQuestionarioSatisfacao | null>
    ) {
      state.pesquisa = payload;
      state.pesquisa_updated_at = new Date();
    },
    marcaClienteRespondeuQuestionario(state, { payload }: PayloadAction<string>) {
      if (!payload) return;
      if (state.clientesQueResponderamQuestionario.includes(payload)) return;
      state.clientesQueResponderamQuestionario.push(payload);
    },
  },
});

export const questionarioSatisfacaoActions = reducer.actions;

export default reducer.reducer;
